module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    on: {
      "click": _vm.closeAreaTableModal
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    class: _vm.addButtonClass
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'wasteSegregationCreate'
      }
    }
  }, [_c('button', {
    staticClass: " btn gradientbt"
  }, [_vm._v("Add Waste Segregation")])])], 1), _vm._v(" "), _c('v-server-table', {
    ref: "wasteSegregationTable",
    attrs: {
      "url": "",
      "limit": 5,
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(props) {
        return [_c('div', {
          staticClass: "active_wrp"
        }, [_c('a', {
          staticClass: "fa fa-edit",
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.action(props.row)
            }
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "py-2 text-center row"
        }, [_c('label', {
          staticClass: "toggle"
        }, [_c('input', {
          staticClass: "toggle-checkbox",
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": props.row.isActive
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return (function (e) { return _vm.activateSegregationModal(props.row); })($event)
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "slider"
        }), _vm._v(" "), _c('span', {
          staticClass: "labels",
          attrs: {
            "data-on": "Active",
            "data-off": "Deactivate"
          }
        })])])])]
      }
    }, {
      key: "wasteCollectionAreaCount",
      fn: function(props) {
        return [_c('div', {
          staticClass: "active_wrp"
        }, [(props.row.wasteCollectionAreaCount) ? _c('a', {
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.showArea(props.row)
            }
          }
        }, [_vm._v(_vm._s(props.row.wasteCollectionAreaCount))]) : _vm._e(), _vm._v(" "), (!props.row.wasteCollectionAreaCount) ? _c('p', [_vm._v("\n                            " + _vm._s(props.row.wasteCollectionAreaCount) + "\n                        ")]) : _vm._e()])]
      }
    }])
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2aa88040", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2aa88040"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/wasteSegregation/wasteSegregation.vue
// module id = 2287
// module chunks = 0